import PropTypes from 'prop-types';
import { trackUserInteractionOnce } from '../helpers/checkoutTracking';
import { PANES } from '../constants/checkoutConstants';
import styles from './styles/checkoutRadioContainer.scss';

import { Radio } from 'dibs-elements/exports/Radio';
import RowContainer from './CheckoutRowContainer';
import { CheckoutActions } from './CheckoutActions';

const CheckoutRadioContainer = ({
    type,
    serviceId,
    label,
    isClickable = true,
    isSelected = false,
    isDisabled = false,
    noMargin = false,
    actions,
    children,
    onSelect,
    wrapperClass,
    actionsWrapperClass,
    noPadding,
}) => (
    <RowContainer
        isClickable={isClickable}
        isSelected={isSelected}
        isDisabled={isDisabled}
        noMargin={noMargin}
        wrapperClass={wrapperClass}
        noPadding={noPadding}
    >
        <Radio
            label={label}
            name={type}
            value={serviceId}
            inputId={[type, serviceId].join('-')}
            checked={isSelected}
            disabled={isDisabled}
            theme={{ children: styles.children }}
            dataTn={[type, serviceId, 'wrapper'].join('-')}
            onChange={(value, event) => {
                trackUserInteractionOnce();
                if (!isClickable) {
                    return null;
                }
                return onSelect(value, event);
            }}
        >
            {actions && (
                <CheckoutActions
                    type={type}
                    serviceId={serviceId}
                    actions={actions}
                    actionsWrapperClass={actionsWrapperClass}
                />
            )}
            {children && <div className={styles.content}>{children}</div>}
        </Radio>
    </RowContainer>
);

CheckoutRadioContainer.propTypes = {
    type: PropTypes.oneOf([PANES.PANE_SHIPPING, PANES.PANE_PAYMENT]).isRequired,
    serviceId: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    isClickable: PropTypes.bool,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    noMargin: PropTypes.bool,
    actions: PropTypes.object,
    children: PropTypes.node,
    onSelect: PropTypes.func.isRequired,
    wrapperClass: PropTypes.string,
    actionsWrapperClass: PropTypes.string,
    noPadding: PropTypes.bool,
};

export default CheckoutRadioContainer;
